import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number, docUUID: string) =>
    makeCall<undefined>('DELETE', `/api/v2/user/${userId}/document/${docUUID}`);
